import {
  transformDefault,
  transformNavigationMenu,
  transformSiteNavigation,
  transformFooter,
  transformJourneyTimelines,
  transformHeroComponent,
  transformSiteLogo,
  transformFaqGroups,
  transformNewsTimelines,
  transformRichTextComponent,
  transformQuickLinksDesignOne,
  transformQuickLinksDesignTwo,
  transformHeroBanner,
  transformAwardsTimelines,
  transformAboutAmwayBrands,
  transformStepsToBusinessOwner,
  transformDownloadLink,
  transformAmwayHighlights,
  transformAmwayBusinessLinks,
  transformBannerRichText,
  transformOurPromises,
  transformMeetOurPeople,
  transformShopByCategory,
  transformNotification,
  transformShopByContainer,
  transformFeaturedCards,
  transformVideoBanner,
  transformfeaturedArticleCarousal,
  transformMyAccountContainer,
  transformFeaturedDisplayCard,
  transformContentCard,
  transformContentCardCarousel,
  transformPromotionCard,
  transformArticleCard,
  transformResourceCard,
  transformHighlightsC,
  transformStandardBannerNoCTA,
  transformArticleOverview,
  transformVideoSection,
  transformFaq,
  transformTextOnly,
  transformImageWithOptionalCTA,
  transformAudioPlayer,
  transformGridViewImageGallery,
  transformAccordionComponent,
} from '../component-transformers';
import transformImageAndText from '../component-transformers/ImageAndText-transformer/ImageAndText-transformer';

import { ComponentTransformerRegistry, ComponentType } from './types/propTypes';

const componentTransformerRegistry: ComponentTransformerRegistry = {
  [ComponentType.accordion_component]: transformAccordionComponent,
  [ComponentType.image_and_text]: transformImageAndText,
  [ComponentType.grid_view_image_gallery]: transformGridViewImageGallery,
  [ComponentType.audio_player]: transformAudioPlayer,
  [ComponentType.text_only]: transformTextOnly,
  [ComponentType.image_with_optional_cta]: transformImageWithOptionalCTA,
  [ComponentType.mega_menu]: transformNavigationMenu,
  [ComponentType.top_navigation]: transformSiteNavigation,
  [ComponentType.default]: transformDefault,
  [ComponentType.footer]: transformFooter,
  [ComponentType.journey_timelines]: transformJourneyTimelines,
  [ComponentType.hero_component]: transformHeroComponent,
  [ComponentType.site_logo]: transformSiteLogo,
  [ComponentType.faq_groups]: transformFaqGroups,
  [ComponentType.faq]: transformFaq,
  [ComponentType.news_timelines]: transformNewsTimelines,
  [ComponentType.rich_text_component]: transformRichTextComponent,
  [ComponentType.quick_links_design_one]: transformQuickLinksDesignOne,
  [ComponentType.quick_links_design_two]: transformQuickLinksDesignTwo,
  [ComponentType.hero_banner]: transformHeroBanner,
  [ComponentType.awards_timelines]: transformAwardsTimelines,
  [ComponentType.about_amway_brands]: transformAboutAmwayBrands,
  [ComponentType.amway_highlights]: transformAmwayHighlights,
  [ComponentType.steps_to_business_owner]: transformStepsToBusinessOwner,
  [ComponentType.download_links]: transformDownloadLink,
  [ComponentType.amway_business_links]: transformAmwayBusinessLinks,
  [ComponentType.banner_rich_text_component]: transformBannerRichText,
  [ComponentType.amway_promises]: transformOurPromises,
  [ComponentType.meet_our_scientists]: transformMeetOurPeople,
  [ComponentType.featured_cards]: transformShopByCategory,
  [ComponentType.notification]: transformNotification,
  [ComponentType.shop_by_container]: transformShopByContainer,
  [ComponentType.featured_card_container]: transformFeaturedCards,
  [ComponentType.video_banner]: transformVideoBanner,
  [ComponentType.featured_articles_carousal]: transformfeaturedArticleCarousal,
  [ComponentType.my_account_container]: transformMyAccountContainer,
  [ComponentType.featured_display_card]: transformFeaturedDisplayCard,
  [ComponentType.content_card]: transformContentCard,
  [ComponentType.content_card_carousal]: transformContentCardCarousel,
  [ComponentType.article_carousel]: transformContentCardCarousel,
  [ComponentType.promotion_carousel]: transformContentCardCarousel,
  [ComponentType.resource_carousel]: transformContentCardCarousel,
  [ComponentType.resource_card]: transformResourceCard,
  [ComponentType.article_card]: transformArticleCard,
  [ComponentType.promotion_card]: transformPromotionCard,
  [ComponentType.highlights_c]: transformHighlightsC,
  [ComponentType.standard_banner_no_cta]: transformStandardBannerNoCTA,
  [ComponentType.article_overview]: transformArticleOverview,
  [ComponentType.video_section]: transformVideoSection,
};

export default componentTransformerRegistry;
